export default __webpack_public_path__ + "static/orange-robot-dbde16dd6ad6609da5ba83851fb2abf9.png";